import { DateTime } from 'luxon';
import { AxiosRequestConfig } from 'axios';
import { GreetResult as Greet, Profile, UserSimple } from '../models';
import type { Reply } from '../models/reply';
import { DateString } from 'types/support';
import { DateFilterType } from '~/App/Contexts/DateContext';
import { InteractionOptions } from '~/App/Contexts/InteractionContext';

export interface GreetResult {
  id: string;
  greet: Greet;
  profile: Profile;
  replies_count: number;
  stats: {
    opened: boolean;
    views: number;
    shares: number;
    reactions: number;
    watched: boolean;
    clicked: boolean;
    reacted: boolean;
  };
  replies: Reply[];
  results_url: string;
  results_modal_url: string;
  awaiting_reply: boolean | null;
  sent_at: DateString;
  last_replied_at: DateString;
  last_modified_at: DateString;
}

export interface AutomationAccount {
  uuid: string;
  created_at: DateTime;
  service: string;
  name: string;
}

export interface GreetStats {
  id: string;
  unique_opens: string | number;
  unique_views: string | number;
  unique_clicks: string | number;
  unique_reactions: string | number;
  greet_total: string | number;
  greet_opens: string | number;
  greet_views: string | number;
  greet_clicks: string | number;
  greet_reactions: string | number;
  greet_replies: string | number;
  assignee: UserSimple;
  greet_open_percentage: string | number | null;
  greet_view_percentage: string | number | null;
  greet_click_percentage: string | number | null;
  greet_reaction_percentage: string | number | null;
  greet_reply_percentage: string | number | null;
  total: number;
}

export enum MediaType {
  Stock = 'StockMedia',
  Uploaded = 'Media',
}

export interface Media {
  id?: string | null;
  type: MediaType;
  name: string;
  tags?: string;
  url: string;
  created_at?: string;
}

export interface UploadUrlResponse {
  method: AxiosRequestConfig['method'];
  url: string;
  uuid: string;
  timestamp: number;
}

export interface GreetFilters {
  profile_id?: string;
  assignee_id?: string;
  date_start?: string;
  date_end?: string;
  date_filter?: DateFilterType;
  interaction?: InteractionOptions;
  campaign_id?: string;
}
